import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {CustomerFluidSubPageLayout} from "components/layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import React, {useEffect, useState} from "react";
import {
    CustomerRequestsTab,
    StyledTabs,
    GlobalDropdownStyles
} from "./style/CustomerRequestsPage.styles";
import {Tabs} from "antd";
import {useFetch} from "hooks/useFetch";
import {useStore} from "hooks/useStore";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import SupportRequestTab from "./components/SupportRequestTab";
import CourierPlanningRequestTab from "./components/CourierPlanningRequestTab";
import RequestsDataTable from "./components/RequestsDataTable";

const {TabPane} = Tabs;

const DEFAULT_FILTERS = {
    startDate: null,
    endDate: null,
    status: undefined,
    type: undefined,
    subType: undefined
};

const CustomerRequestsPage = observer(() => {
    const {t} = useTranslation();
    const stores = useStore();
    const [subcompanyId, setSubcompanyId] = useState(stores.meStore.selectedSubCompanyId);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10
    });
    const [filters, setFilters] = useState(() => ({...DEFAULT_FILTERS}));
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [detailModalVisible, setDetailModalVisible] = useState(false);

    const formattedFilters = {
        startDate: filters.startDate ? filters.startDate.format("YYYY-MM-DD") : undefined,
        endDate: filters.endDate ? filters.endDate.format("YYYY-MM-DD") : undefined,
        status: filters.status,
        type: filters.type,
        subType: filters.subType
    };

    const [loading, data, setData, setLoading, refetch] = useFetch({
        fetchFn: () =>
            stores.shiftRequestStore.getShiftRequestList({
                page: pagination.current,
                limit: pagination.pageSize,
                subCompanyId: subcompanyId,
                ...formattedFilters
            }),
        dependencies: [
            pagination.current,
            pagination.pageSize,
            subcompanyId,
            formattedFilters.startDate,
            formattedFilters.endDate,
            formattedFilters.status,
            formattedFilters.type,
            formattedFilters.subType
        ],
        initialCall: true
    });

    const handlePaginationChange = (page, pageSize) => {
        setPagination({
            current: page,
            pageSize: pageSize
        });
    };

    const handleUpdateFilters = newFilters => {
        setFilters(prev => ({
            ...prev,
            ...newFilters
        }));
        setPagination(prevPagination => ({
            current: 1,
            pageSize: prevPagination.pageSize
        }));
    };
    const handleViewDetails = request => {
        setSelectedRequest(request);
        setDetailModalVisible(true);
    };

    useEffect(() => {
        const newSubcompanyId = stores.meStore.selectedSubCompanyId;
        setSubcompanyId(newSubcompanyId);
        setPagination(prevPagination => ({
            current: 1,
            pageSize: prevPagination.pageSize
        }));
        setFilters({...DEFAULT_FILTERS});
    }, [stores.meStore.selectedSubCompanyId]);

    return (
        <CustomerFluidSubPageLayout>
            <GlobalDropdownStyles />
            <CustomerMenuHeader />
            <CustomerRequestsTab>
                <StyledTabs defaultActiveKey="courierPlanningRequest" destroyInactiveTabPane={true}>
                    <TabPane
                        tab={t("screens.customerRequests.courierPlanningRequest")}
                        key="courierPlanningRequest"
                    >
                        <CourierPlanningRequestTab
                            tableData={data}
                            tableLoading={loading}
                            refetchTable={refetch}
                            onPaginationChange={handlePaginationChange}
                            filters={filters}
                            handleUpdateFilters={handleUpdateFilters}
                        />
                    </TabPane>
                    <TabPane
                        tab={t("screens.customerRequests.supportRequest")}
                        key="supportRequest"
                    >
                        <SupportRequestTab
                            tableData={data}
                            tableLoading={loading}
                            refetchTable={refetch}
                            onPaginationChange={handlePaginationChange}
                            filters={filters}
                            handleUpdateFilters={handleUpdateFilters}
                        />
                    </TabPane>
                    <TabPane
                        tab={"Taleplerim"}
                        key="myRequests"
                    >
                        <RequestsDataTable
                            title={"Taleplerim"}
                            data={data?.data}
                            loading={loading}
                            pagination={data?.pagination}
                            onPaginationChange={handlePaginationChange}
                            filters={filters}
                            handleUpdateFilters={handleUpdateFilters}
                            onViewDetails={handleViewDetails}
                        />
                    </TabPane>
                </StyledTabs>
            </CustomerRequestsTab>
        </CustomerFluidSubPageLayout>
    );
});

export default CustomerRequestsPage;
